import {
  InstantAnswerBuilderFn,
  InstantAnswerContext,
  InstantAnswerScenario,
} from "@faire/help-center-self-serve/types";
import { StrictLocalizeFunction } from "@faire/web--source/common/localization";
import React from "react";

import {
  MessageRetailerOrBrandButton,
  additionalDataRequiredForContactingRetailerOrBrandCTA,
} from "../../shared/instantAnswerUtils";

import { VatIssueIA } from "./instantAnswersComponents/orders/VatIssueIA";

export const vatIssueIA: InstantAnswerBuilderFn = (strictLocalize) => ({
  titleBuilder: (context) => getAnswer(context, strictLocalize).getTitle(),
  descriptionBuilder: (context) =>
    getAnswer(context, strictLocalize).getDescription(),
  primaryCtaBuilder: {
    textBuilder: (context) => {
      return MessageRetailerOrBrandButton(context, strictLocalize)?.label;
    },
    onClickFunctionBuilder: (context) => {
      return MessageRetailerOrBrandButton(context, strictLocalize)?.onClick;
    },
  },

  additionalRequiredData:
    additionalDataRequiredForContactingRetailerOrBrandCTA(),
});

const getAnswer = (
  _context: InstantAnswerContext,
  strictLocalize: StrictLocalizeFunction
): InstantAnswerScenario => {
  return {
    getTitle: () => VAT_ISSUE_TITLE(strictLocalize),
    getDescription: () => VAT_ISSUE_DESCRIPTION(),
  };
};

const VAT_ISSUE_TITLE = (strictLocalize: StrictLocalizeFunction) =>
  strictLocalize({
    defaultMessage: "Non VAT registered retailer",
    description: {
      text: "Title for the instant answer about VAT issue",
    },
  });

const VAT_ISSUE_DESCRIPTION = () => {
  return <VatIssueIA />;
};
